import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconNewCalendar: React.FC<IconProps> = ({ ...props }) => {
  const fill = '#200E32';
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 16.8698V9.25684H21V16.9308C21 20.0698 19.0241 21.9998 15.8628 21.9998H8.12733C4.99561 21.9998 3 20.0298 3 16.8698ZM7.95938 14.4098C7.50494 14.4308 7.12953 14.0698 7.10977 13.6108C7.10977 13.1508 7.46542 12.7708 7.91987 12.7498C8.36443 12.7498 8.72997 13.1008 8.73985 13.5498C8.7596 14.0108 8.40395 14.3908 7.95938 14.4098ZM12.0198 14.4098C11.5653 14.4308 11.1899 14.0698 11.1701 13.6108C11.1701 13.1508 11.5258 12.7708 11.9802 12.7498C12.4248 12.7498 12.7903 13.1008 12.8002 13.5498C12.82 14.0108 12.4643 14.3908 12.0198 14.4098ZM16.0505 18.0898C15.596 18.0798 15.2305 17.6998 15.2305 17.2398C15.2206 16.7798 15.5862 16.4008 16.0406 16.3908H16.0505C16.5148 16.3908 16.8902 16.7708 16.8902 17.2398C16.8902 17.7098 16.5148 18.0898 16.0505 18.0898ZM11.1701 17.2398C11.1899 17.6998 11.5653 18.0608 12.0198 18.0398C12.4643 18.0208 12.82 17.6408 12.8002 17.1808C12.7903 16.7308 12.4248 16.3798 11.9802 16.3798C11.5258 16.4008 11.1701 16.7798 11.1701 17.2398ZM7.09989 17.2398C7.11965 17.6998 7.49506 18.0608 7.94951 18.0398C8.39407 18.0208 8.74973 17.6408 8.72997 17.1808C8.72009 16.7308 8.35456 16.3798 7.90999 16.3798C7.45554 16.4008 7.09989 16.7798 7.09989 17.2398ZM15.2404 13.6008C15.2404 13.1408 15.596 12.7708 16.0505 12.7608C16.4951 12.7608 16.8507 13.1198 16.8705 13.5608C16.8804 14.0208 16.5247 14.4008 16.0801 14.4098C15.6257 14.4198 15.2503 14.0698 15.2404 13.6108V13.6008Z"
        fill={fill}
      />
      <path
        opacity="0.3"
        d="M3.00342 9.25723C3.01626 8.67023 3.06566 7.50523 3.15852 7.13023C3.63273 5.02123 5.24304 3.68123 7.54491 3.49023H16.456C18.7381 3.69123 20.3682 5.04023 20.8424 7.13023C20.9343 7.49523 20.9837 8.66923 20.9965 9.25723H3.00342Z"
        fill={fill}
      />
      <path
        d="M8.30465 6.59C8.73934 6.59 9.06535 6.261 9.06535 5.82V2.771C9.06535 2.33 8.73934 2 8.30465 2C7.86996 2 7.54395 2.33 7.54395 2.771V5.82C7.54395 6.261 7.86996 6.59 8.30465 6.59Z"
        fill={fill}
      />
      <path
        d="M15.6948 6.59C16.1196 6.59 16.4555 6.261 16.4555 5.82V2.771C16.4555 2.33 16.1196 2 15.6948 2C15.2601 2 14.9341 2.33 14.9341 2.771V5.82C14.9341 6.261 15.2601 6.59 15.6948 6.59Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconNewCalendar;
